import { crv, cva } from '@/styled-system/css';

const sizeVariants = crv('size', {
  xs: {
    blockSize: 'auto',
    borderRadius: 'obj.soft',
    maxInlineSize: '360px',
  },
  sm: {
    blockSize: 'auto',
    borderRadius: 'obj.soft',
    maxInlineSize: '540px',
  },
  md: {
    blockSize: 'auto',
    borderRadius: 'obj.soft',
    maxInlineSize: '720px',
  },
  lg: {
    blockSize: 'auto',
    borderRadius: 'obj.soft',
    maxInlineSize: '900px',
  },
  xl: {
    blockSize: 'auto',
    borderRadius: 'obj.soft',
    maxInlineSize: '1080px',
  },
  fullScreen: {
    blockSize: '100%',
    borderRadius: 'obj.fullWidth',
    maxInlineSize: '100%',
  },
});

export const modalContentRecipe = cva({
  base: {
    'display': 'flex',
    'flexDirection': 'column',
    'backgroundColor': 'bg.elevated.sheet',
    'boxShadow': 'lg',
    'position': 'relative',
    'blockSize': 'auto',
    'inlineSize': '100%',
    'minBlockSize': '0',
    'transitionProperty': {
      _motionReduce: 'none',
      _motionSafe: 'opacity, transform',
    },
    'transitionDuration': {
      _motionReduce: '0s',
      _motionSafe: '{durations.200}',
    },
    'transitionTimingFunction': '{easings.ease-out}',
    'zIndex': 2,

    '&:not(:has(.c11n_modal__header))': {
      paddingBlockStart: 'layout.loosest',
    },
  },
  variants: {
    open: {
      true: {
        opacity: 1,
        transform: 'none',
      },
      false: {
        opacity: 0,
        transform: 'scale(0.975)',
      },
    },
    scrollDocument: {
      true: {},
      false: {
        maxBlockSize: '100%',
      },
    },
    ...sizeVariants,
  },
});
